import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { Column } from '@repo/ui/data-table'
import { CheckMarkIcon, MinusIcon } from '@repo/ui/icons'

import { CseContact } from '../../../../lib/types/models/cse/cse-contact'
import { formatPhoneNumber } from '../../../../utils/functions/format-phone-number'

export const cseContactTableColumns: Column<CseContact>[] = [
  {
    header: 'Nom',
    accessorKey: 'lastName',
    enableSorting: true,
    cell: ({ row }) => row.original.lastName.toUpperCase()
  },
  {
    header: 'Prénom',
    accessorKey: 'firstName',
    enableSorting: true
  },
  {
    header: 'Fonction',
    accessorKey: 'position',
    enableSorting: true
  },
  {
    header: 'Email',
    accessorKey: 'email',
    enableSorting: true,
    cell: ({ row }) => row.original.email || '-'
  },
  {
    header: 'Mobile',
    accessorKey: 'phone',
    enableSorting: true,
    cell: ({ row }) => (row.original.phone ? formatPhoneNumber(row.original.phone) : '-')
  },
  {
    header: 'Fixe',
    accessorKey: 'fixedPhone',
    enableSorting: true,
    cell: ({ row }) => (row.original.fixedPhone ? formatPhoneNumber(row.original.fixedPhone) : '-')
  },
  {
    header: 'Peut recevoir des emails ?',
    accessorKey: 'canReceiveEmails',
    enableSorting: true,
    cell: ({ row }) => {
      const canReceive = row.original.canReceiveEmails
      return (
        <div
          className={cn('p-2 rounded-full w-fit', {
            'bg-green-light': canReceive,
            'bg-red-light': !canReceive
          })}
        >
          {canReceive ? (
            <CheckMarkIcon color={tailwindColors.green.DEFAULT} width="16px" height="16px" />
          ) : (
            <MinusIcon color={tailwindColors.red.DEFAULT} width="16px" height="16px" />
          )}
        </div>
      )
    }
  }
]
